var _circle, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPriorityIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#E12A0E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0717 19.3412C24.6168 18.8863 23.9171 18.8863 23.4621 19.3412C23.0071 19.7961 23.0071 20.4959 23.4621 20.9509L24.8267 22.3155H22.3423C17.1988 22.3155 13 26.5142 13 31.6577C13 36.8012 17.1987 41 22.3423 41H26.611C27.2407 41 27.7308 40.4753 27.7308 39.8802C27.7308 39.2505 27.2061 38.7604 26.611 38.7604H22.3425C18.4237 38.6906 15.2746 35.5065 15.2746 31.6225C15.2746 27.7386 18.4235 24.5546 22.3425 24.5546H24.8269L23.4623 25.9192C23.0074 26.3741 23.0074 27.0738 23.4623 27.5288C23.6722 27.7387 23.9871 27.8788 24.267 27.8788C24.547 27.8788 24.8618 27.7739 25.0717 27.5288L28.3608 24.2397C28.5707 24.0298 28.7108 23.7499 28.7108 23.435C28.7108 23.1202 28.6059 22.8402 28.3608 22.6303L25.0717 19.3412Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6295 24.5547H45.0859C45.7156 24.5547 46.2057 24.0299 46.2057 23.4349C46.2057 22.8401 45.6809 22.3151 45.0859 22.3151L32.6295 22.3153C31.9998 22.3153 31.5097 22.8401 31.5097 23.4351C31.5097 24.0299 31.9996 24.5547 32.6295 24.5547V24.5547Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1209 38.6906H32.6295C31.9998 38.6906 31.5097 39.2153 31.5097 39.8103C31.5097 40.44 32.0345 40.9301 32.6295 40.9301H45.0859C45.7156 40.9301 46.2057 40.4054 46.2057 39.8103C46.2406 39.1804 45.7158 38.6906 45.1208 38.6906H45.1209Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1209 33.2321H32.6295C31.9998 33.2321 31.5097 33.7569 31.5097 34.3519C31.5097 34.9467 32.0345 35.4717 32.6295 35.4717H45.0859C45.7156 35.4717 46.2057 34.947 46.2057 34.3519C46.2057 33.7571 45.7158 33.2321 45.1208 33.2321H45.1209Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1209 27.7737H32.6295C31.9998 27.7737 31.5097 28.2985 31.5097 28.8935C31.5097 29.5232 32.0345 30.0133 32.6295 30.0133H45.0859C45.7156 30.0133 46.2057 29.4886 46.2057 28.8935C46.2406 28.2636 45.7158 27.7737 45.1208 27.7737H45.1209Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriorityIcon);
export default __webpack_public_path__ + "static/media/priority-icon.f0532819629fea160797f4fb330c45a8.svg";
export { ForwardRef as ReactComponent };